// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"d2d423ae","220":"1648f7f7","335":"d707807e","563":"5de923bd","564":"537cadbb","622":"5002bfc8","639":"57f7d87e","672":"e62f9aa1","759":"a4d90e00","762":"a390beb1"}[chunkId] + ".chunk.js";
};